import { css, unsafeCSS } from 'lit';
import SotbitButton from '../button';
import styles from './button-icon.scss?inline';

/**
 * @cssproperty --badge-color
 */
export default class SotbitButtonIcon extends SotbitButton {
    static styles = [
        SotbitButton.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = SotbitButton.properties;
}
